import { KeyboardEvent } from 'react';

export const preventCharsInNumberInput = (e: KeyboardEvent) => {
  if (e.code === 'Minus' || e.code === 'Equal' || e.code === 'KeyE' || e.code === 'Comma' || e.code === 'Period') {
    e.preventDefault();
  }
};
